export const handleGoogleLogin = () => {
  const API_URL = window._env_.VITE_API_URL;
  const redirectUri = encodeURIComponent(`${API_URL}/login/oauth2/code/google`);
  window.location.href = `${API_URL}/oauth2/authorization/google?redirect_uri=${redirectUri}`;
};
